import { useCallback, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { message } from 'antd';

import { commonStore, loginAction } from 'stores';

import { config } from 'miles.config';

export const useLogout = (): [() => void] => {
  const { logout } = useAuth0();

  const handleLogout = useCallback(() => {
    logout({
      logoutParams: {
        returnTo: `${config.adminURL}/auth/logout`,
      },
    });
  }, [logout]);

  return [handleLogout];
};

export const useAuth = () => {
  const user = commonStore((state) => state.user);
  const isSessionExpired = commonStore((state) => state.isSessionExpired);

  const { getAccessTokenSilently } = useAuth0();

  const [handleLogout] = useLogout();

  useEffect(() => {
    (async () => {
      try {
        const { access_token: accessToken, id_token: idToken } = await getAccessTokenSilently({ detailedResponse: true, authorizationParams: { prompt: 'none' } });

        if (!user && accessToken) {
          loginAction({ idToken, accessToken });
        }
      } catch (error) {
        message.error('Get Access Token Silently Error');
      }
    })();
  }, []);

  useEffect(() => {
    if (isSessionExpired && user) {
      message.error('Session expired!');

      handleLogout();
    }
  }, [isSessionExpired, user]);
};
